module.exports = __webpack_public_path__ + "img/cam_setting.svg";